import styled from "@emotion/styled";
import MenuIcon from "@mui/icons-material/Menu";

const Container = styled.button`
  display: none;
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;

  ${(p) => p.theme.media.mobileDown} {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: ${(p) => p.theme.text.fontSizes.xl};
    color: ${(p) => p.theme.text.colors.primary};
    cursor: pointer;
    transition: all 0.2s ease-in-out;

    &:hover {
      opacity: 0.7;
    }
  }

  color: ${(p) => p.theme.navbar.colors.text};
  * {
    color: ${(p) => p.theme.navbar.colors.text};
  }
`;

export const HamburgerMenu = (props: { onClick: () => void }) => {
  const { onClick } = props;
  return (
    <Container onClick={onClick}>
      <MenuIcon />
    </Container>
  );
};
